<template>
  <div class="home-search">
    <div class="container">
      <div class="search-content">
        <div class="searchbutton" @click="submitSearch()"></div>
        <input
          v-model.trim="searchContent"
          @keyup.13="submitSearch"
          :placeholder="$t('searchInput.placeholder')"
          id="homeSearchContent"
          autocomplete="off"
          ref="homesearch"
          @focus="focused = true"
          @blur="focused = false"
        />
        <div class="searchicon"></div>
        <search-tip
          :content="searchContent"
          :focused="focused"
          extra-class="search-common"
        ></search-tip>
      </div>
      <div class="quicksearch-content">
        <div class="title">{{ $t("searchInput.qucik") }}</div>
        <div class="item" @click="toOEP4list()">
          {{ $t("searchInput.oep4") }}
        </div>
        <div class="item" @click="toContractlist()">
          {{ $t("searchInput.contracts") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $httpService from "../../common/utils";
import searchTip from "@/components/common/searchTip";

export default {
  components: {
    searchTip
  },
  data() {
    return {
      searchContent: "",
      focused: false
    };
  },
  mounted() {
    /* this.$refs.homesearch.focus(); */
  },
  methods: {
    toOEP4list() {
      if (this.$route.params.net === "testnet") {
        this.$router.push({
          name: "TokenListTest",
          params: {
            contractType: "oep4",
            pageSize: 10,
            pageNumber: 1,
            net: "testnet"
          }
        });
      } else {
        this.$router.push({
          name: "TokenList",
          params: { contractType: "oep4", pageSize: 10, pageNumber: 1 }
        });
      }
    },
    toContractlist() {
      if (this.$route.params.net === "testnet") {
        this.$router.push({
          name: "ContractListTest",
          params: { pageSize: 10, pageNumber: 1, net: "testnet" }
        });
      } else {
        this.$router.push({
          name: "ContractList",
          params: { pageSize: 10, pageNumber: 1 }
        });
      }
    },
    notFound() {
      // this.$toast.center(this.$t('error.format'));
      this.$message({ message: this.$t("error.format") });
    },
    searchHash($searchContent) {
      $httpService
        .get("/transactions/" + $searchContent)
        .then(res => {
          if (res.code != 0) {
            this.notFound();
          } else {
            if (this.$route.params.net == undefined) {
              this.$router.push({
                name: "TransactionDetail",
                params: { tx_hash: $searchContent }
              });
            } else {
              this.$router.push({
                name: "TransactionDetailTest",
                params: { tx_hash: $searchContent, net: "testnet" }
              });
            }
          }
        })
        .catch(error => {
          this.notFound();
        });
    },
    searchAddress($searchContent) {
      if (this.$route.params.net == undefined) {
        this.$router.push({
          name: "AddressDetail",
          params: {
            address: $searchContent,
            assetName: "ALL",
            pageSize: 10,
            pageNumber: 1
          }
        });
      } else {
        this.$router.push({
          name: "AddressDetailTest",
          params: {
            address: $searchContent,
            assetName: "ALL",
            pageSize: 10,
            pageNumber: 1,
            net: "testnet"
          }
        });
      }
    },
    searchContract($searchContent, isContractAccount = false) {
      const goContractDetail = () => {
        if (this.$route.params.net == undefined) {
          this.$router.push({
            name: "ContractDetail",
            params: {
              contractHash: $searchContent,
              contractType: "other",
              pageSize: 10,
              pageNumber: 1
            }
          });
        } else {
          this.$router.push({
            name: "ContractDetailTest",
            params: {
              contractHash: $searchContent,
              contractType: "other",
              pageSize: 10,
              pageNumber: 1,
              net: "testnet"
            }
          });
        }
      };

      if (isContractAccount) {
        goContractDetail();
        return;
      }

      $httpService
        .get("/contracts/" + $searchContent)
        .then(res => {
          if (res.code != 0) {
            this.notFound();
          } else {
            console.log(res);
            console.log("this.$route", this.$route);
            if (res.result == null) {
              this.notFound();
            } else {
              if (res.result.type == "") {
                goContractDetail();
              } else {
                if (this.$route.params.net == undefined) {
                  this.$router.push({
                    name: "TokenDetail",
                    params: {
                      contractType: res.result.type,
                      tokenName: res.result.name,
                      contractHash: $searchContent,
                      pageSize: 10,
                      pageNumber: 1
                    }
                  });
                } else {
                  this.$router.push({
                    name: "TokenDetailTest",
                    params: {
                      contractType: res.result.type,
                      tokenName: res.result.name,
                      contractHash: $searchContent,
                      pageSize: 10,
                      pageNumber: 1,
                      net: "testnet"
                    }
                  });
                }
              }
            }
          }
        })
        .catch(error => {
          this.notFound();
        });
    },
    searchONTID($searchContent) {
      $httpService
        .get("/ontids/" + $searchContent + "/ddo")
        .then(res => {
          if (res.code != 0) {
            this.notFound();
          } else {
            if (this.$route.params.net == undefined) {
              this.$router.push({
                name: "OntIdDetail",
                params: {
                  ontid: $searchContent,
                  pageSize: 10,
                  pageNumber: 1
                }
              });
            } else {
              this.$router.push({
                name: "OntIdDetailTest",
                params: {
                  ontid: $searchContent,
                  pageSize: 10,
                  pageNumber: 1,
                  net: "testnet"
                }
              });
            }
          }
        })
        .catch(error => {
          this.notFound();
        });
    },
    searchHeight($searchContent) {
      $httpService
        .get("/blocks/" + $searchContent)
        .then(response => {
          if (response.code != 0) {
            this.notFound();
          } else {
            if (this.$route.params.net == undefined) {
              this.$router.push({
                name: "blockDetail",
                params: { param: $searchContent }
              });
            } else {
              this.$router.push({
                name: "blockDetailTest",
                params: { param: $searchContent, net: "testnet" }
              });
            }
          }
        })
        .catch(error => {
          this.notFound();
        });
    },
    async submitSearch() {
      const content = this.searchContent;

      const len = content.length;
      if (!len) {
        return;
      }

      /* block height */
      if (len <= 11 && /^\d+$/.test(content)) {
        this.searchHeight(content);
        return;
      }

      /* address */
      if (len === 34 && content[0] === "A") {
        this.searchAddress(content);
        return;
      }

      /* contract hash */
      if (len === 40) {
        this.searchContract(content);
        return;
      }

      /* contract hash */
      if (len === 42) {
        if (content.startsWith("did:ont:")) {
          this.searchONTID(content);
          return;
        }

        // Ox地址或者合约
        if (
          content.slice(0, 2) === "0x" &&
          this.$HelperTools.isHexString(content.slice(-40))
        ) {
          const { result: isContractAccount } = await $httpService.get(
            `/contracts/checkIfExist/${content}`
          );
          if (isContractAccount) {
            this.searchContract(content);
          } else {
            this.searchAddress(content);
          }
          return;
        }
      }

      /* txhash */
      if (len === 64 && this.$HelperTools.isHexString(content)) {
        this.searchHash(content);
        return;
      }

      if (
        len === 66 &&
        content.slice(0, 2) === "0x" &&
        this.$HelperTools.isHexString(content.slice(-64))
      ) {
        this.searchHash(content);
        return;
      }

      this.notFound();
    }
  }
};
</script>

<style lang="less" scoped>
@keyframes showcase {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* 定义keyframe动画，命名为blink */
@keyframes blink {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
/* 添加兼容性前缀 */
@-webkit-keyframes blink {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@-moz-keyframes blink {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@-ms-keyframes blink {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@-o-keyframes blink {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.home-search {
  animation: showcase 1s;
  .container {
    padding-top: 49px;
    .search-content {
      position: relative;
      border-bottom: solid #000 2px;
      padding-bottom: 20px;
      display: flex;
      align-items: center;
      flex-flow: row-reverse;
      input {
        border: 0;
        border-radius: 0;
        caret-color: rgba(0, 0, 0, 1);
        font-size: 18px;
        font-family: Avenir;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        /* line-height: 21px; */
        transition: all ease 0.5s;
        width: calc(100% - 40px);
        padding-right: 10px;
        padding-left: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        outline: none;
      }
      /*       input:focus {
        outline: none;
        border-bottom: solid #000 2px;
        transition: all ease 0.5s;
      } */
      ::-webkit-input-placeholder {
        /* WebKit browsers */
        font-size: 18px;
        font-family: Avenir;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        line-height: 21px;
        transition: all ease 0.3s;
      }
      ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        font-size: 18px;
        font-family: Avenir;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        line-height: 21px;
        transition: all ease 0.3s;
      }
      :-ms-input-placeholder {
        /* Internet Explorer 10+ */
        font-size: 18px;
        font-family: Avenir;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        line-height: 21px;
        transition: all ease 0.3s;
      }
      input:focus::-webkit-input-placeholder {
        /* WebKit browsers */
        font-size: 18px;
        font-family: Avenir;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.1);
        line-height: 21px;
        transition: all ease 0.3s;
      }
      input:focus::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        font-size: 18px;
        font-family: Avenir;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.1);
        line-height: 21px;
        transition: all ease 0.3s;
      }
      input:focus:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        font-size: 18px;
        font-family: Avenir;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.1);
        line-height: 21px;
        transition: all ease 0.3s;
      }
      input:focus + .searchicon {
        opacity: 1;
        transition: all ease 0.3s;
      }
      .searchicon {
        /*         position: absolute;
        left: 0px;
        top: 0px; */
        width: 20px;
        height: 20px;
        background-image: url("../../assets/images/common/search.svg");
        background-repeat: no-repeat;
        background-size: 94%;
        /* transform: translateY(2px); */
        opacity: 0.1;
        transition: all ease 0.3s;
      }
      .searchbutton {
        /*         position: absolute;
        right: 0%;
        top: 0%; */
        cursor: pointer;
        width: 20px;
        height: 20px;
        background-image: url("../../assets/images/common/search.png");
        background-size: 100%;
        background-repeat: no-repeat;
        /*         transform: translateY(4px); */
      }
      .searchbutton:hover {
        opacity: 0.6;
        transition: opacity ease 0.3s;
      }
    }
    .quicksearch-content {
      padding-top: 30px;
      display: flex;
      .title {
        font-size: 13px;
        font-family: Avenir;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.6);
        line-height: 16px;
      }
      .item {
        cursor: pointer;
        font-size: 14px;
        font-family: Avenir;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        line-height: 16px;
        padding-left: 20px;
        transition: all ease 0.3s;
      }
      .item:hover {
        color: rgba(0, 0, 0, 0.5);
        transition: all ease 0.3s;
      }
    }
  }
}
@media only screen and (max-width: 960px) {
  .home-search {
    animation: showcase 1s;
    .container {
      padding-top: 40px;
      .search-content {
        position: relative;
        border-bottom: solid #000 2px;
        padding-bottom: 20px;
        display: flex;
        align-items: center;
        flex-flow: row-reverse;
        input {
          width: calc(100% - 40px);
          padding-right: 10px;
          padding-left: 10px;
          border: 0;
          caret-color: rgba(0, 0, 0, 1);
          font-size: 14px;
          font-family: Avenir;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
          /* line-height: 21px; */
          transition: all ease 0.5s;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          outline: none;
        }
        ::placeholder {
          text-overflow: ellipsis;
        }
        ::-webkit-input-placeholder {
          /* WebKit browsers */
          font-size: 14px;
          font-family: Avenir;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.3);
          line-height: 21px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        ::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          font-size: 14px;
          font-family: Avenir;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.3);
          line-height: 21px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        :-ms-input-placeholder {
          /* Internet Explorer 10+ */
          font-size: 14px;
          font-family: Avenir;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.3);
          line-height: 21px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        input:focus::-webkit-input-placeholder {
          /* WebKit browsers */
          font-size: 14px;
          font-family: Avenir;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.3);
          line-height: 21px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        input:focus::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          font-size: 14px;
          font-family: Avenir;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.3);
          line-height: 21px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        input:focus:-ms-input-placeholder {
          /* Internet Explorer 10+ */
          font-size: 14px;
          font-family: Avenir;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.3);
          line-height: 21px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        input:focus + .searchicon {
          opacity: 1;
          transition: all ease 0.3s;
        }
        .searchicon {
          /*           position: absolute;
          left: 0px;
          top: 0px; */
          width: 16px;
          height: 16px;
          background-image: url("../../assets/images/common/search.svg");
          background-repeat: no-repeat;
          background-size: 100%;
          /*           transform: translateY(1px); */
          opacity: 0.1;
          transition: all ease 0.3s;
        }
        .searchbutton {
          /*           position: absolute;
          right: 0%;
          top: 0%; */
          cursor: pointer;
          width: 16px;
          height: 16px;
          background-image: url("../../assets/images/common/search.png");
          background-size: 100%;
          background-repeat: no-repeat;
          /*           transform: translateY(2px); */
        }
        .searchbutton:hover {
          opacity: 0.6;
          transition: opacity ease 0.3s;
        }
      }
    }
  }
}
.search-content {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/home/search.vue